export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "global__supportEmailAddress--escaped": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["support", "@", "nuuly.com"])},
        "help__chat--title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["How Can We Help?"])}
      }
    }
  })
}
